// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

// Afidium
import { SimpleTextareaFieldComponent } from './simple-textarea-field.component';
import { FormFieldModule } from '../form-field/form-field.module';

@NgModule({
    declarations: [
        SimpleTextareaFieldComponent
    ],
    imports: [
        CommonModule,
        FormFieldModule,
        ReactiveFormsModule,
    ],
    exports: [SimpleTextareaFieldComponent],
})
export class SimpleTextareaFieldModule {}
